import React, {useState} from "react";
import FirstMileTabs from "./first_mile_tabs";
import TaskAllocationPage from "./task_allocation/task_allocation_page";
import DriverRepositoryPage from "./driver_repository/driver_repository_page";
import LocationRepositoryPage from "./location_repository/location_repository_page";
import FirstMileOrdersPage from "./first_mile_orders_page/first_mile_orders_page";

const FirstMilePage = ({isFormUrl}) => {
    const [activeTab, setActiveTabs] = useState(1);

    const handleOnChangeTabs = (events, updatedTabValue) => {
        setActiveTabs(updatedTabValue);
    };
    const selectedTabContent = () => {
        switch (activeTab) {
            case 0:
                return <FirstMileOrdersPage/>;
            case 1:
                return <TaskAllocationPage/>;
            case 2:
                return <DriverRepositoryPage/>;
            case 3:
                return <LocationRepositoryPage/>;
        }
    };
    return (
        <>
            <div style={{width: "100%", height: "100%",  ...(isFormUrl ? { position: "fixed" } : {}) }}>
                <FirstMileTabs
                    activeTabValue={activeTab}
                    handleOnChangeTabs={handleOnChangeTabs}
                />
                {selectedTabContent()}
            </div>
        </>
    );
};
export default FirstMilePage;
